<template>
  <BlocoFormularioCadastro voltar="/profissional" @salvar="salvar()">
    <template #form>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.geral.$error,
          'panel-danger': v$.$validationGroups.geral.$error,
        }"
        class="panel"
      >
        <div id="info_gerais" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Geral
            <span class="pull-right">{{ resumoGeral }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <div
                :class="{ 'has-error': v$.profissional.nome.$error }"
                class="form-group"
              >
                <input
                  id="_id"
                  v-model="profissional._id"
                  data-test-id="input-_id"
                  type="hidden"
                  name="_id"
                  class="form-control"
                />
                <label for="nome"
                  >Nome
                  <sup>(1)</sup>
                </label>
                <input
                  id="nome"
                  v-model="profissional.nome"
                  data-test-id="input-nome"
                  type="text"
                  class="form-control"
                  name="nome"
                  placeholder="Nome completo"
                  @input="v$.profissional.nome.$touch()"
                />
                <span v-if="v$.profissional.nome.$dirty">
                  <span v-if="!v$.profissional.nome.required" class="help-block"
                    >Campo é obrigatório.</span
                  >
                  <span
                    v-if="!v$.profissional.nome.minLength"
                    class="help-block"
                    >Campo deve ter pelo menos
                    {{ v$.profissional.nome.$params.minLength.min }}
                    letras.</span
                  >
                  <span
                    v-if="!v$.profissional.nome.maxLength"
                    class="help-block"
                    >Campo deve ter no máximo
                    {{ v$.profissional.nome.$params.maxLength.max }}
                    letras.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <div
                :class="{ 'has-error': v$.profissional.numeroConselho.$error }"
                class="form-group"
              >
                <label for="numeroConselho"
                  >Número do conselho
                  <sup>(1)</sup>
                </label>
                <input
                  id="numeroConselho"
                  v-model="profissional.numeroConselho"
                  v-mask="'999999999999999'"
                  data-test-id="input-numeroconselho"
                  type="text"
                  class="form-control"
                  name="numeroConselho"
                  placeholder="Número do conselho"
                  @input="v$.profissional.numeroConselho.$touch()"
                />
                <span v-if="v$.profissional.numeroConselho.$dirty">
                  <span
                    v-if="!v$.profissional.numeroConselho.required"
                    class="help-block"
                    >Campo é obrigatório.</span
                  >
                  <span
                    v-if="!v$.profissional.numeroConselho.maxLength"
                    class="help-block"
                    >Campo deve ter no máximo
                    {{ v$.profissional.numeroConselho.$params.maxLength.max }}
                    letras.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.contato.$error,
          'panel-danger': v$.$validationGroups.contato.$error,
        }"
        class="panel"
      >
        <div id="contato_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title">
            Contato
            <span class="pull-right">{{ resumoContato }}</span>
          </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.profissional.celular.$error }"
                class="form-group"
              >
                <label for="celular"
                  >Celular
                  <sup>(2)</sup>
                </label>
                <input
                  id="celular"
                  v-model="profissional.celular"
                  v-mask="'(99) 99999-9999'"
                  data-test-id="input-celular"
                  type="text"
                  class="form-control"
                  name="celular"
                  placeholder="Celular"
                />
                <span v-if="v$.profissional.celular.$dirty">
                  <span
                    v-if="!v$.profissional.celular.requiredIf"
                    class="help-block"
                    >Celular ou Telefone para contato são obrigatórios.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
              <div
                :class="{ 'has-error': v$.profissional.telefone.$error }"
                class="form-group"
              >
                <label for="telefone"
                  >Telefone
                  <sup>(2)</sup>
                </label>
                <input
                  id="telefone"
                  v-model="profissional.telefone"
                  v-mask="'(99) 9999-9999'"
                  data-test-id="input-telefone"
                  type="text"
                  class="form-control"
                  name="telefone"
                  placeholder="Telefone"
                />
                <span v-if="v$.profissional.telefone.$dirty">
                  <span
                    v-if="!v$.profissional.telefone.requiredIf"
                    class="help-block"
                    >Celular ou Telefone para contato são obrigatórios.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <div
                :class="{ 'has-error': v$.profissional.email.$error }"
                class="form-group"
              >
                <label for="email">E-mail</label>
                <input
                  id="email"
                  v-model="profissional.email"
                  data-test-id="input-email"
                  type="email"
                  class="form-control"
                  name="email"
                  placeholder="E-mail"
                  @input="v$.profissional.email.$touch()"
                />
                <span v-if="v$.profissional.email.$dirty">
                  <span v-if="!v$.profissional.email.email" class="help-block"
                    >Email inválido.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.atendimento.$error,
          'panel-danger': v$.$validationGroups.atendimento.$error,
        }"
        class="panel"
      >
        <div id="atendimento_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title"> Atendimento </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <div
                :class="{ 'has-error': v$.profissional.unidade.$error }"
                class="form-group"
              >
                <label for="unidade"
                  >Unidade
                  <sup>(1)</sup>
                </label>
                <select
                  id="unidade"
                  v-model="profissional.unidade"
                  data-test-id="select-unidade"
                  name="unidade"
                  class="form-control"
                  multiple
                >
                  <option
                    v-for="unidade in unidades"
                    :key="unidade._id"
                    :value="unidade.nome"
                    >{{ unidade.nome }}</option
                  >
                </select>
                <span v-if="v$.profissional.unidade.$dirty">
                  <span
                    v-if="!v$.profissional.unidade.required"
                    class="help-block"
                    >Campo é obrigatório.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <div
                :class="{ 'has-error': v$.profissional.especialidade.$error }"
                class="form-group"
              >
                <label for="especialidade"
                  >Especialidade
                  <sup>(1)</sup>
                </label>
                <select
                  id="especialidade"
                  v-model="profissional.especialidade"
                  data-test-id="select-especialidade"
                  name="especialidade"
                  class="form-control"
                  multiple
                >
                  <option
                    v-for="especialidade in especialidades"
                    :key="especialidade._id"
                    :value="especialidade.nome"
                    >{{ especialidade.nome }}</option
                  >
                </select>
                <span v-if="v$.profissional.especialidade.$dirty">
                  <span
                    v-if="!v$.profissional.especialidade.required"
                    class="help-block"
                    >Campo é obrigatório.</span
                  >
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2">
              <div
                :class="{ 'has-error': v$.profissional.avaliacao.$error }"
                class="form-group"
              >
                <label for="avaliacao"
                  >Avaliação
                  <sup>(1)</sup>
                </label>
                <select
                  id="avaliacao"
                  v-model="profissional.avaliacao"
                  data-test-id="select-avaliacao"
                  name="avaliacao"
                  class="form-control"
                >
                  <option disabled value="">Selecione</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
                <span v-if="v$.profissional.avaliacao.$dirty">
                  <span
                    v-if="!v$.profissional.avaliacao.required"
                    class="help-block"
                    >Campo é obrigatório.</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{
          'panel-primary': !v$.$validationGroups.atendimentos.$error,
          'panel-danger': v$.$validationGroups.atendimentos.$error,
        }"
        class="panel"
      >
        <div id="horarios_titulo" class="panel-heading" role="tab">
          <h4 class="panel-title"> Horário </h4>
        </div>

        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class="form-group">
                <label for="unidade_horario">Unidade</label>
                <select
                  id="unidade_horario"
                  v-model="unidadeSelecionada"
                  data-test-id="select-unidade_horario"
                  class="form-control"
                  name="unidade_horario"
                >
                  <option
                    v-for="unidade in profissional.unidade"
                    :key="unidade"
                    :value="unidade"
                    >{{ unidade }}</option
                  >
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
              <div class="form-group">
                <label for="especialidade_horario">Especialidade</label>
                <select
                  id="especialidade_horario"
                  v-model="especialidadeSelecionada"
                  data-test-id="select-especialidade_horario"
                  class="form-control"
                  name="especialidade_horario"
                >
                  <option v-if="!unidadeSelecionada" disabled
                    >Selecione a unidade e depois a especialidade.</option
                  >
                  <option
                    v-for="especialidade in profissional.especialidade"
                    :key="especialidade"
                    :disabled="
                      !naoPossuiEspecialidade(unidadeSelecionada, especialidade)
                    "
                    :value="especialidade"
                    >{{ especialidade
                    }}{{
                      !naoPossuiEspecialidade(unidadeSelecionada, especialidade)
                        ? ' (já adicionado)'
                        : ''
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
              <button
                data-test-id="button-adicionarhorariounidadeespecialidade-12"
                class="btn btn-primary"
                style="margin-top: 21px"
                type="button"
                @click="adicionarHorarioUnidadeEspecialidade()"
                ><span class="fa fa-plus" /> Adicionar</button
              >
            </div>
          </div>
          <div
            v-for="atendimento in profissional.atendimentos"
            :key="`${atendimento.unidade}-${atendimento.especialidade}`"
          >
            <div class="unidade-especialidade-linha row">
              <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <span class="unidade-especialidade-titulo">
                  {{ atendimento.unidade }} - {{ atendimento.especialidade }}
                </span>
              </div>
              <div
                class="pull-right text-right col-xs-6 col-sm-6 col-md-6 col-lg-6"
              >
                <div class="btn-group" role="group">
                  <button
                    data-test-id="button-auto-13"
                    type="button"
                    class="btn btn-default dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="fa fa-plus" /> Adicionar dia
                    <span class="caret" />
                  </button>
                  <ul class="dropdown-menu">
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Segunda')"
                        data-test-id="a-adicionardiasemana-14"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Segunda')
                        "
                        >Segunda</a
                      ></li
                    >
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Terça')"
                        data-test-id="a-adicionardiasemana-15"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Terça')
                        "
                        >Terça</a
                      ></li
                    >
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Quarta')"
                        data-test-id="a-adicionardiasemana-16"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Quarta')
                        "
                        >Quarta</a
                      ></li
                    >
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Quinta')"
                        data-test-id="a-adicionardiasemana-17"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Quinta')
                        "
                        >Quinta</a
                      ></li
                    >
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Sexta')"
                        data-test-id="a-adicionardiasemana-18"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Sexta')
                        "
                        >Sexta</a
                      ></li
                    >
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Sábado')"
                        data-test-id="a-adicionardiasemana-19"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Sábado')
                        "
                        >Sábado</a
                      ></li
                    >
                    <li
                      ><a
                        v-if="naoPossuiHorario(atendimento, 'Domingo')"
                        data-test-id="a-adicionardiasemana-20"
                        href="#"
                        @click.prevent="
                          adicionardiaSemana(atendimento, 'Domingo')
                        "
                        >Domingo</a
                      ></li
                    >
                  </ul>
                  <Longpress
                    :value="atendimento"
                    :on-confirm="removerHorarioUnidadeEspecialidade"
                    class="btn btn-default"
                    duration="5"
                    pressing-text="Removendo em {$rcounter}"
                    action-text="Removendo todos"
                    ><span class="fa fa-trash" /> Remover todos</Longpress
                  >
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div
                v-for="horario in atendimento.horarios"
                :key="horario.diaSemana"
                class="col-xs-6 col-sm-4 col-md-3 col-lg-2"
              >
                <div class="panel panel-default" style="margin-bottom: 10px">
                  <div class="panel-heading">
                    <strong>{{ horario.diaSemana }}</strong>
                  </div>
                  <div class="panel-body" style="padding: 0">
                    <table class="table table-striped">
                      <tbody>
                        <tr>
                          <td>
                            <div
                              v-for="hora in horario.horas"
                              :key="`${hora.horarioInicio}${hora.horarioTermino}`"
                              class="input-group input-group-sm"
                            >
                              <input
                                v-mask="'99:99'"
                                data-test-id="input-auto-21"
                                :class="{ 'campo-hora-dirty': hora.dirty }"
                                :value="hora.horarioInicio"
                                type="text"
                                class="form-control campo-hora-valor"
                                @input="
                                  atualizaHora(
                                    profissional,
                                    hora,
                                    'horarioInicio',
                                    $event.target.value
                                  )
                                "
                              />
                              <span class="input-group-addon">-</span>
                              <input
                                v-mask="'99:99'"
                                data-test-id="input-auto-22"
                                :class="{ 'campo-hora-dirty': hora.dirty }"
                                :value="hora.horarioTermino"
                                type="text"
                                class="form-control campo-hora-valor"
                                @input="
                                  atualizaHora(
                                    profissional,
                                    hora,
                                    'horarioTermino',
                                    $event.target.value
                                  )
                                "
                              />
                              <span
                                class="input-group-addon"
                                @click.prevent="removerHora(horario, hora)"
                                ><span class="fa fa-trash"
                              /></span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="panel-footer" style="padding: 0">
                    <div
                      class="btn-group btn-group-justified"
                      role="group"
                      aria-label="..."
                    >
                      <div class="btn-group" role="group">
                        <button
                          data-test-id="button-adicionarhorario-23"
                          type="button"
                          class="btn btn-sm btn-default"
                          @click="adicionarHorario(horario)"
                          ><span class="fa fa-plus" /> Horário</button
                        >
                      </div>
                      <div class="btn-group" role="group">
                        <Longpress
                          :value="{
                            atendimento: atendimento,
                            horario: horario,
                          }"
                          :on-confirm="removerHorarioDia"
                          class="btn btn-sm btn-default"
                          duration="3"
                          pressing-text="Em {$rcounter}"
                          action-text="Removido"
                          ><span class="fa fa-trash" /> Todos</Longpress
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>(1) Campos obrigatórios.</p>
      <p>(2) Celular ou Telefone para contato são obrigatórios.</p>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {
  email,
  maxLength,
  minLength,
  required,
  requiredIf,
} from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import Longpress from 'vue-longpress'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import router from '@/router'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'
import MensagemServico from '@/servicos/MensagemServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'
import UnidadeServico from '@/servicos/UnidadeServico'

const especialidadeServico = new EspecialidadeServico()
const unidadeServico = new UnidadeServico()
const profissionalServico = new ProfissionalServico()
const mensagemServico = new MensagemServico()

export default {
  name: 'ProfissionalCadastro',
  components: { Longpress, BlocoFormularioCadastro },
  directives: { mask: AwesomeMask },

  setup() {
    useMenu(10)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      confirmarExclusao: false,
      unidades: [],
      especialidades: [],
      unidadeSelecionada: '',
      especialidadeSelecionada: '',
      profissional: {
        nome: '',
        numeroConselho: '',
        email: '',
        telefone: '',
        celular: '',
        unidade: [],
        avaliacao: '',
        especialidade: [],
        atendimentos: [],
      },
    }
  },
  validations: {
    profissional: {
      nome: { required, minLength: minLength(5), maxLength: maxLength(60) },
      numeroConselho: { required, maxLength: maxLength(15) },
      email: { email },
      celular: {
        requiredIf: requiredIf(function () {
          return !this.profissional.telefone
        }),
      },
      telefone: {
        requiredIf: requiredIf(function () {
          return !this.profissional.celular
        }),
      },
      unidade: { required },
      avaliacao: { required },
      especialidade: { required },
      atendimentos: { required },
    },
    $validationGroups: {
      geral: ['profissional.nome', 'profissional.numeroConselho'],
      contato: [
        'profissional.celular',
        'profissional.telefone',
        'profissional.email',
      ],
      atendimento: [
        'profissional.unidade',
        'profissional.avaliacao',
        'profissional.especialidade',
      ],
      atendimentos: ['profissional.atendimentos'],
    },
  },
  computed: {
    resumoGeral() {
      return `${this.profissional.nome}, ${this.profissional.numeroConselho}.`
    },
    resumoContato() {
      let result = ''
      result += this.profissional.telefone
        ? ` Telefone: ${this.profissional.telefone}`
        : ''
      result += this.profissional.celular
        ? ` Celular: ${this.profissional.celular}`
        : ''
      result += this.profissional.email
        ? ` Email: ${this.profissional.email}`
        : ''
      return result
    },
  },
  created() {
    this.recuperarUnidades()
    this.recuperarEspecialidades()
    this.recuperarProfissional()
  },
  methods: {
    atualizaHora(profissional, hora, campo, valor) {
      const h = moment(valor, 'HH:mm')

      if (valor.length === 5 && h.isValid()) {
        hora[campo] = valor
        hora.dirty = true
      }
    },
    adicionarHorarioUnidadeEspecialidade() {
      if (this.unidadeSelecionada && this.especialidadeSelecionada) {
        this.profissional.atendimentos.push({
          unidade: this.unidadeSelecionada,
          especialidade: this.especialidadeSelecionada,
          horarios: [],
        })
      } else {
        mensagemServico.alerta(
          'Para adicionar, deve ser selecionado uma unidade e especialidade'
        )
      }
      this.unidadeSelecionada = ''
      this.especialidadeSelecionada = ''
    },
    removerHorarioUnidadeEspecialidade(atendimento) {
      const index = this.profissional.atendimentos.indexOf(atendimento)
      this.profissional.atendimentos.splice(index, 1)
    },
    removerHorarioDia(props) {
      const index = props.atendimento.horarios.indexOf(props.horario)
      props.atendimento.horarios.splice(index, 1)
    },
    removerHora(horario, hora) {
      const index = horario.horas.indexOf(hora)
      horario.horas.splice(index, 1)
    },
    adicionarHorario(horario) {
      horario.horas.push({
        horarioInicio: '',
        horarioTermino: '',
      })
    },
    adicionardiaSemana(atendimento, dia) {
      atendimento.horarios.push({
        diaSemana: dia,
        horas: [],
      })

      this.ordenarHorariosSemana(atendimento)
    },
    ordenarHorariosSemana(atendimento) {
      atendimento.horarios.sort((horario1, horario2) => {
        moment.locale('pt-br')
        const dia1 = moment(horario1.diaSemana, 'dddd')
        const dia2 = moment(horario2.diaSemana, 'dddd')
        if (dia1.isBefore(dia2)) {
          return -1
        } else if (dia1.isAfter(dia2)) {
          return 1
        } else {
          return 0
        }
      })
    },
    naoPossuiHorario(atendimento, dia) {
      const horarios = atendimento.horarios.filter((h) => h.diaSemana === dia)
      return !(horarios && horarios.length > 0)
    },
    naoPossuiEspecialidade(unidade, especialidade) {
      const atendimentos = this.profissional.atendimentos.filter(
        (a) => a.unidade === unidade && a.especialidade === especialidade
      )
      return !(atendimentos && atendimentos.length > 0)
    },
    recuperarUnidades() {
      unidadeServico
        .recuperarTodos()
        .then((result) => {
          this.unidades = result.unidades
        })
        .catch((err) => {
          console.error(err)
        })
    },
    recuperarEspecialidades() {
      especialidadeServico.recuperarTodos({ ativo: true }).then((result) => {
        this.especialidades = result.especialidades
      })
    },
    recuperarProfissional() {
      const profissionalId = this.$route.params.id

      if (profissionalId) {
        profissionalServico.recuperar(profissionalId).then((result) => {
          this.profissional._id = profissionalId
          this.profissional.avaliacao = result.profissional.avaliacao
            ? 'S'
            : 'N'
          this.profissional.nome = result.profissional.nome
          this.profissional.numeroConselho = result.profissional.numeroConselho
          this.profissional.email = result.profissional.email
          this.profissional.telefone = result.profissional.telefone
          this.profissional.celular = result.profissional.celular
          result.profissional.unidade.forEach((unidade) => {
            this.profissional.unidade.push(unidade.toUpperCase())
          })
          this.profissional.especialidade = result.profissional.especialidade
          this.profissional.ativo = result.profissional.ativo
          this.profissional.usuario = result.profissional.usuario
          this.profissional.atendimentos = result.profissional.atendimentos
          this.profissional.atendimentos.forEach((atendimento) =>
            this.ordenarHorariosSemana(atendimento)
          )
        })
      }
    },
    salvar() {
      this.v$.$touch()
      if (this.v$.profissional.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        const prof = {
          nome: this.profissional.nome,
          numeroConselho: this.profissional.numeroConselho,
          email: this.profissional.email,
          telefone: this.profissional.telefone,
          celular: this.profissional.celular,
          unidade: this.profissional.unidade,
          avaliacao: this.profissional.avaliacao === 'S',
          especialidade: this.profissional.especialidade,
          atendimentos: this.profissional.atendimentos,
          usuario: this.profissional.email,
          ativo: true,
          _id: this.profissional._id,
        }

        if (prof._id) {
          profissionalServico.atualizar(prof._id, prof).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Profissional' })
          })
        } else {
          profissionalServico.criar(prof).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Profissional' })
          })
        }
      }
    },
  },
}
</script>

<style>
.table {
  margin-bottom: 0;
}

.unidade-especialidade-linha {
  margin-top: 20px;
  border-bottom: 1px solid #ecf0f1;
}

.unidade-especialidade-titulo {
  font-size: 2em;
}

.campo-hora-dirty {
  border: 2px solid #3498db;
  border-radius: 3px;
}
</style>
